import { useQuery } from '@tanstack/react-query'
import api from '../../config/axios-config.jsx'
import { membersQueryKeys } from '../constants.js'

/**
 * Fetches media parent data (post or task comment).
 * @param {string} projectId - ID of the project.
 * @param {string} search - Search param to use to search members.
 * @param {Object} options - Additional options for the query.
 * @returns {Object} - The query object with parent media data. The response includes a header 'dt-type'
 * that indicates whether the returned item is a media post or a media task comment, depending on where
 * the media is located.
 */

export const useGetProjectContactsQuery = (projectId, search = '', options) => {
  const handleQuery = async () => {
    const config = {
      method: 'GET',
      params: {
        projectId,
        search
      }
    }

    const { data } = await api('/api/contacts', config)

    return data
  }

  return useQuery({
    queryKey: [membersQueryKeys.GET_PROJECT_CONTACTS, projectId, search],
    queryFn: handleQuery,
    enabled: !!projectId,
    ...options
  })
}
